import {useDispatch} from 'react-redux';

import {AppDispatch} from 'store/Store';

export default function useStoreDispatch() {
  const dispatch = useDispatch<AppDispatch>();

  return dispatch;
}
